export default {
  /**
   *  @type {string} 検索画面
   */
  search: '/admin/tag/',
  /**
   * 参照画面
   * @param {string} id TagID
   */
  refer: (id) => {
    return `/admin/tag/refer/${id}`;
  },
  /**
   * @type {string} 新規作成画面
   */
  newEdit: '/admin/tag/edit/',
  /**
   * 編集画面
   * @param {string} id TagID
   */
  edit: (id) => {
    return `/admin/tag/edit/${id}`;
  },
};
